module.exports = __webpack_public_path__ + "img/roles_7.716de54b.png";